import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

// https://refreshless.com/nouislider/examples/#section-merging-tooltips
// with adjustments
const mergeOverlappingTooltips = (slider) => {
  const threshold = 15;
  const separator = ' - ';

  slider.off('update.overlapping');

  const tooltips = slider.getTooltips();
  const origins = slider.getOrigins();

  // Move tooltips into the origin element. The default stylesheet handles this.
  tooltips.forEach(function (tooltip, index) {
    if (tooltip) {
      origins[index].appendChild(tooltip);
    }
  });

  slider.on(
    'update.overlapping',
    function onSliderUpdate(values, handle, unencoded, tap, positions) {
      const pools = [[]];
      const poolPositions = [[]];
      const poolValues = [[]];
      let atPool = 0;

      // Assign the first tooltip to the first pool, if the tooltip is configured
      if (tooltips[0]) {
        pools[0][0] = 0;
        poolPositions[0][0] = positions[0];
        poolValues[0][0] = values[0];
      }

      for (var i = 1; i < positions.length; i++) {
        if (!tooltips[i] || positions[i] - positions[i - 1] > threshold) {
          atPool++;
          pools[atPool] = [];
          poolValues[atPool] = [];
          poolPositions[atPool] = [];
        }

        if (tooltips[i]) {
          pools[atPool].push(i);
          poolValues[atPool].push(values[i]);
          poolPositions[atPool].push(positions[i]);
        }
      }

      pools.forEach((pool, poolIndex) => {
        const handlesInPool = pool.length;

        for (let j = 0; j < handlesInPool; j += 1) {
          const handleNumber = pool[j];

          if (j === handlesInPool - 1) {
            let offset = 0;

            poolPositions[poolIndex].forEach((value) => {
              offset += 1000 - value;
            });

            const direction = 'right';
            const last = handlesInPool - 1;
            const lastOffset = 1000 - poolPositions[poolIndex][last];
            offset = offset / handlesInPool - lastOffset;

            // Center this tooltip over the affected handles
            tooltips[handleNumber].textContent = poolValues[poolIndex]
              .map((val) => {
                const valNumber = Number(val);
                return `$${valNumber % 1 ? valNumber.toFixed(2) : valNumber}`;
              })
              .join(separator);
            tooltips[handleNumber].style.display = 'block';
            tooltips[handleNumber].style[direction] = `${offset}%`;

            // Adjust positions to be in the container
            const tooltipPosition =
              tooltips[handleNumber].getBoundingClientRect();
            if (tooltipPosition.width) {
              const sliderPosition = tooltips[handleNumber]
                .closest('.noUi-target')
                .getBoundingClientRect();

              if (tooltipPosition.left < sliderPosition.left) {
                let leftAdjustment = sliderPosition.left - tooltipPosition.left;
                tooltips[handleNumber].style[
                  direction
                ] = `calc(${offset}% - ${leftAdjustment}px)`;
              } else if (tooltipPosition.right > sliderPosition.right) {
                let rightAdjustment =
                  tooltipPosition.right - sliderPosition.right;
                tooltips[handleNumber].style[
                  direction
                ] = `calc(${offset}% + ${rightAdjustment}px)`;
              }
            }
          } else {
            // Hide this tooltip
            tooltips[handleNumber].style.display = 'none';
          }
        }
      });
    }
  );
};

const productsBrowserFacetSlider = () => ({
  inputLow: 0,
  inputHigh: 0,

  get normalizedValueFromSlider() {
    if (
      this.inputLow === this.originalRange[0] &&
      this.inputHigh === this.originalRange[1]
    ) {
      return '';
    }

    return `range::${JSON.stringify({
      low: String(this.inputLow),
      high: String(this.inputHigh),
    })}`;
  },

  get normalizedValueActive() {
    return this.$refs.activeFacetModel._x_model.get();
  },

  init() {
    this.setValues();

    this.originalRange = this.facet.range;
    this.normalizedStep = Math.max(this.facet.step, 1);

    this.$nextTick(() => {
      this.$watch('normalizedValueActive', (value) => {
        value = Array.isArray(value) ? value[0] : value;
        if (value && value.startsWith('range::')) {
          const [, json] = value.split('::');
          const { low, high } = JSON.parse(json);
          this.inputLow = Math.min(
            Math.max(Number(low), this.originalRange[0]),
            this.originalRange[1]
          );
          this.inputHigh = Math.max(
            Math.min(Number(high), this.originalRange[1]),
            this.originalRange[0]
          );
          this.slider.set([this.inputLow, this.inputHigh], true, true);
        } else {
          this.inputLow = this.originalRange[0];
          this.inputHigh = this.originalRange[1];
          this.slider.set(
            [this.originalRange[0], this.originalRange[1]],
            true,
            true
          );
        }
      });
    });

    this.$watch('normalizedValueFromSlider', (value) => {
      this.$refs.activeFacetModel._x_model.set([value].filter(Boolean));
    });

    this.slider = noUiSlider.create(this.$refs.slider, {
      animate: false,
      start: [this.inputLow, this.inputHigh],
      connect: true,
      margin: this.normalizedStep,
      step: this.normalizedStep,
      tooltips: {
        to: (n) => `$${n % 1 ? n.toFixed(2) : n}`,
      },
      range: {
        min: this.originalRange[0],
        max: this.originalRange[1],
      },
    });

    mergeOverlappingTooltips(this.slider);

    this.slider.on('change', (_, __, values) => {
      this.inputLow = Number(values[0].toFixed(2));
      this.inputHigh = Number(values[1].toFixed(2));
    });

    this.$watch('facet.range', (value, oldValue) => {
      if (
        !this.facet.facet_active &&
        (value[0] !== oldValue[0] || value[1] !== oldValue[1])
      ) {
        this.originalRange = value;
        this.slider.updateOptions({
          range: {
            min: this.originalRange[0],
            max: this.originalRange[1],
          },
        });
        mergeOverlappingTooltips(this.slider);
        this.inputLow = this.originalRange[0];
        this.inputHigh = this.originalRange[1];
        this.slider.set(
          [this.originalRange[0], this.originalRange[1]],
          true,
          true
        );
      }
    });

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.$nextTick(() => {
            this.slider.updateOptions({});
            mergeOverlappingTooltips(this.slider);
          });
        }
      });
    });

    this.intersectionObserver.observe(this.$refs.slider);
  },

  destroy() {
    this.slider.destroy();
    this.intersectionObserver.disconnect();
  },

  setValues() {
    const active = this.facet.active || this.facet.range;
    this.inputLow = active[0];
    this.inputHigh = active[1];
  },
});

export default productsBrowserFacetSlider;
